import { inventoryReportApi } from "@/services/api/inventoryReport.api";
import appSnackbarService from "@/services/appSnackbar.service";

export const inventoryReportState = {
  state: {
    inventoryReports: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false,
    error: ""
  },
  mutations: {
    INVENTORY_REPORTS_FETCH_SUCCESS(state, payload) {
      state.inventoryReports = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
    },
    INVENTORY_REPORTS_FETCH_START(state) {
      state.fetching = true;
    },
    INVENTORY_REPORTS_FETCH_ERROR(state, payload) {
      state.fetching = false;
      state.error = payload;
    },
  },
  actions: {
    getInventoryReports(context, request) {
      context.commit("INVENTORY_REPORTS_FETCH_START");

      const promise = new Promise((resolve, reject) => {
        inventoryReportApi
        .getAll(request)
          .then(response => {
            context.commit("INVENTORY_REPORTS_FETCH_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            context.commit("INVENTORY_REPORTS_FETCH_ERROR", error);
            reject(error);
          });
        });
      return promise;
    },
  },
};
